import React from 'react';
import '../Style/About.css'
import Plane from './Plane';
import Give from './Give';
const About = () => {
  return (
    <>
      <Plane />
      <Give/>
      </>
  );
};

export default About;
